import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;

  ${media.xl`
    flex-direction: row;
  `}
`;

export const ItemsListingColumn = styled.div`
  width: 100%;

  ${media.xl`
    width: 70%;
    margin-right: 20px;
    padding-right: 20px;
  `}
`;

export const SummaryColumn = styled.div`
  margin-bottom: 20px;
  width: 100%;

  ${media.xl`
    width: 30%;
  `}
`;

export const SummaryContainer = styled.div`
  margin-bottom: 1px;

  ${media.xl`
    padding: 20px;
    border: 1px solid ${({ theme }: { theme: any }) => theme.defaultColors.lightGrey};
  `}
`;

export const SummarySection = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;

export const SummaryTitle = styled.div`
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  font-size: 18px;
  margin-bottom: 10px;
`;

export const Separator = styled.div`
  padding-top: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid ${({ theme }: { theme: any }) => theme.defaultColors.lighterGrey};
`;

export const EmptyBasketTitle = styled.div`
  font-size: 26px;
  margin-bottom: 12px;
  text-align: center;
`;

export const EmptyBasketContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding: 20px;
  background: ${({ theme }) => theme.defaultColors.lighterGrey};

  ${media.md`
    padding: 50px 170px;
  `}
`;

export const ContinueShoppingRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 50px;
`;

export const NotificationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
